import React, { useContext } from "react";
import i18n from "~/assets/js/Helpers/i18n";
import isEmpty from "lodash.isempty";
import { CheckoutContext, PAGES } from "../../CheckoutProvider";
import { formatDate } from "../TimeSlotSelect/formatDateTime";
import OverviewSection from "./OverviewSection";
import useAreaCookie from "~/assets/js/Helpers/hooks/useAreaCookie";
import PropTypes from "prop-types";
import useGroupOrder from "~/assets/js/global/useGroupOrder";
import { formatTimeslotEntryFromCart } from "~/assets/js/Helpers/timeslot-utils";

const DeliverySlot = ({ edit }) => {
    const cookie = useAreaCookie();
    const isDelivery = cookie.area.type === "delivery" ? true : false;

    return (
        <OverviewSection
            title={isDelivery ? "overview.timeslot" : "overview.pickup"}
            editPage={edit && PAGES.TIME_SLOT_SELECT}
        >
            <DeliverySlotToggleBox />
        </OverviewSection>
    );
};

const DeliverySlotToggleBox = () => {
    const { isGroupOrder, groupCartData } = useGroupOrder();

    const groupOrderTimeslot =
        isGroupOrder &&
        formatTimeslotEntryFromCart(
            groupCartData?.slot_begin,
            groupCartData?.slot_end
        );

    const { state } = useContext(CheckoutContext);

    if (!isGroupOrder && (!state.timeSlot || isEmpty(state.timeSlot))) {
        return (
            <div>Timeslot is empty, please move back and pick a timeslot</div>
        );
    }

    const { deliveryDay, timeSlot } = state.timeSlot;
    const { earlyOnLocation } = state;
    const formattedDate = formatDate(deliveryDay);

    return (
        <div className="togglebox">
            <div className="delivery-overview">
                {isGroupOrder ? (
                    <div className="delivery-overview__day">
                        <strong>{groupOrderTimeslot}</strong>
                    </div>
                ) : (
                    <>
                        <div className="delivery-overview__day">
                            <strong>{formattedDate.append}</strong>, den&nbsp;
                            {formattedDate.date}
                        </div>
                        <div className="delivery-overview__time">
                            <strong>{timeSlot}</strong>
                        </div>
                    </>
                )}

                <div className="delivery-overview__early-loc">
                    {earlyOnLocation && (
                        <span>
                            <i className="fas fa-check"></i>
                            {i18n.t("timeSlotSelect.earyDeliveryConfirmed")}
                        </span>
                    )}
                </div>
            </div>
        </div>
    );
};

DeliverySlot.propTypes = {
    edit: PropTypes.bool,
};

export default DeliverySlot;
